import { TheaterIcon } from './TheaterIcon';

/**
 * author: Austin Andrews
 * id 37350655-CB4D-4D9F-8C90-B8049CA0E48E
 * name theater
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/theater.svg
 * tags
 * - Places 
 * - Home Automation 
 */
export const CinemaIcon = TheaterIcon;
export default CinemaIcon